// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pyCCAYQtrkqDHE8WU8qH{height:100%;max-height:100%;padding-left:48px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/billing/pages/upgrade/ui/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,WAAA,CACA,eAAA,CACA,iBAAA","sourcesContent":[".container {\n  height: 100%;\n  max-height: 100%;\n  padding-left: 48px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `pyCCAYQtrkqDHE8WU8qH`
};
export default ___CSS_LOADER_EXPORT___;
